module.exports = __webpack_public_path__ + "img/small-user.84599e0b.svg";